import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIcons from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'

import { startAppUpdate } from './utils/app-update'
import App from './App.vue'
import router from './router'
import pinia from './stores'
import MyPagination from '@/components/MyPagination.vue'
import { hasPermission } from '@/utils/permission'
import './styles/index.less'
// iconfont 字体图标（菜单等使用，class 用法：<i class="iconfont icon-xxx">）
import 'src/styles/font_5237464_51of7hpp79e/iconfont.css'
import 'src/router/handle.js'
// keep-alive 路由缓存治理守卫（须在 handle.js 之后注册，保证动态路由已就绪）
import 'src/router/cacheGuard.js'
// el-tabs 页签鼠标点击防聚焦（修复点过页签后按 Shift 出现主题色焦点框）
import 'src/utils/tabFocusGuard.js'

// 仅在启用 mock 时动态加载：生产/测试环境 VITE_USE_MOCK=false 时该分支被 tree-shake，不会打包 mock 模块
if (import.meta.env.VITE_USE_MOCK === 'true') {
  await import('./mock')
}

const app = createApp(App)

app.use(pinia)
// 组件库按全量注册，中文语言包
app.use(ElementPlus, { locale: zhCn })
app.use(router)

// 图标全局注册，模板中可直接使用：<el-icon><User /></el-icon>
for (const [name, component] of Object.entries(ElementPlusIcons)) {
  app.component(name, component)
}

// 全局注册通用分页组件，模板中可直接使用：<MyPagination />
app.component('MyPagination', MyPagination)

// 全局权限判断，模板中可直接使用：v-if="$hasPermission('boss.setting')"
app.config.globalProperties.$hasPermission = hasPermission

app.mount('#app')

// Build version is injected by Vite; disabled for local development.
if (import.meta.env.PROD) startAppUpdate(import.meta.env.APP_VERSION)
